import { render } from "./CreateGroup.vue?vue&type=template&id=dc1ba240&scoped=true&ts=true"
import script from "./CreateGroup.vue?vue&type=script&lang=ts"
export * from "./CreateGroup.vue?vue&type=script&lang=ts"

import "./CreateGroup.vue?vue&type=style&index=0&id=dc1ba240&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1ba240"]])

export default __exports__